import { createActionName } from "../../../utility"

export const reducerName = "environment"

export const ENVIRONMENT = createActionName(reducerName, "ENVIRONMENT")
